var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.3337V10.667C12 6.26699 15.6 2.66699 20 2.66699C24.4 2.66699 28 6.26699 28 10.667V21.3337",
    stroke: "#E9ECF1",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 38.667H10.6667C9.2 38.667 8 37.467 8 36.0003V21.3337C8 19.867 9.2 18.667 10.6667 18.667H29.3333C30.8 18.667 32 19.867 32 21.3337V36.0003C32 37.467 30.8 38.667 29.3333 38.667Z",
    fill: "#F2BB41",
    stroke: "#F2BB41",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31.9997C19.2 31.9997 18.6667 31.4663 18.6667 30.6663V26.6663C18.6667 25.8663 19.2 25.333 20 25.333C20.8 25.333 21.3333 25.8663 21.3333 26.6663V30.6663C21.3333 31.4663 20.8 31.9997 20 31.9997Z",
    fill: "#354C75",
    stroke: "#354C75",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock1);
export default __webpack_public_path__ + "static/media/lock1.448a45b307b52b974083a638573fc93f.svg";
export { ForwardRef as ReactComponent };